import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';

import Layout from './Layout';
import MachinesPage from './pages/machine/MachinesPage';
import PlayersPage from './pages/players/PlayersPage';
import LoggedOutPage from "./pages/LoggedOutPage";
import MachineDetailPage from "./pages/machine/MachineDetailPage";
import CategoriesPage from "./pages/category/CategoriesPage";
import GamesPage from './pages/game/GamesPage';
import GameDetailPage from './pages/game/GameDetailPage';
import GameStatsPage from './pages/game/GameStatsPage';
import GameSessionsPage from './pages/game/GameSessionsPage';
import GameSessionDetailPage from './pages/game/GameSessionDetailPage';
import PlayerDetailPage from './pages/players/PlayerDetailPage';
import TransactionsPage from './pages/transactions/TransactionsPage';
import RewardsPage from './pages/reward/RewardsPage';
import RewardDetailPage from './pages/reward/RewardDetailPage';
import CurrenciesPage from "./pages/currency/CurrenciesPage";
import CurrencyEditPage from "./pages/currency/CurrencyEditPage";
import MinigamesPage from "./pages/minigame/MinigamesPage";
import MinigameEditPage from "./pages/minigame/MinigameEditPage";
import MinigameStatsPage from "./pages/minigame-stats/MinigameStatsPage";
import MinigameStatsDetailPage from "./pages/minigame-stats/MinigameStatsDetailPage";
import HiLoStatsPage from "./pages/minigame-stats/HiLoStatsPage";
import GeltsPage from "./pages/gelt/GeltsPage";
import GeltEditPage from "./pages/gelt/GeltEditPage";
import XpLevelConfigsPage from "./pages/xp-level-config/XpLevelConfigsPage";
import XpLevelConfigEditPage from "./pages/xp-level-config/XpLevelConfigEditPage";
import DailyBonusConfigsPage from "./pages/daily-bonus/DailyBonusConfigsPage";
import DailyBonusConfigEditPage from "./pages/daily-bonus/DailyBonusConfigEditPage";
import QueuesPage from "./pages/game/QueuesPage";
import PrizeCategoriesPage from "./pages/prizes/PrizeCategoriesPage";
import PrizeCategoryEditPage from "./pages/prizes/PrizeCategoryEditPage";
import PrizeItemEditPage from "./pages/prizes/PrizeItemEditPage";
import PrizeItemsPage from "./pages/prizes/PrizeItemsPage";
import ChallengesPage from "./pages/challenges/ChallengesPage";
import ChallengeEditPage from "./pages/challenges/ChallengeEditPage";
import LevelPlayPlacementsPage from "./pages/levelplay/LevelPlayPlacementsPage";
import LevelPlayPlacementEditPage from "./pages/levelplay/LevelPlayPlacementEditPage";
import LoginPage from "./pages/LoginPage";
import AuthGuard from "./components/AuthGuard";
import CategoryEditPage from "./pages/category/CategoryEditPage";
import {AuthProvider} from './context/AuthContext';
import AccessDeniedPage from "./pages/AccessDeniedPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* Route for the public login page. It is NOT wrapped in the guard. */}
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="/logged-out" element={<LoggedOutPage/>}/>
                    <Route path="/access-denied" element={<AccessDeniedPage/>}/>

                    {/* All other routes are now children of a single, protected route. */}
                    <Route path="/" element={
                        <AuthGuard>
                            <Layout/>
                        </AuthGuard>
                    }>
                        <Route path="machines" element={<MachinesPage/>}/>
                        <Route path="machines/:id" element={<MachineDetailPage/>}/>

                        <Route path="queues" element={<QueuesPage/>}/>

                        <Route path="games" element={<GamesPage/>}/>
                        <Route path="games/stats" element={<GameStatsPage/>}/>
                        <Route path="games/:gameId" element={<GameDetailPage/>}/>

                        <Route path="game-sessions" element={<GameSessionsPage/>}/>
                        <Route path="game-sessions/:gameSessionId" element={<GameSessionDetailPage/>}/>

                        <Route path="categories" element={<CategoriesPage/>}/>
                        <Route path="categories/:id" element={<CategoryEditPage/>}/>
                        <Route
                            path="players"
                            element={
                                <ProtectedRoute component={PlayersPage} action="read"><PlayersPage/></ProtectedRoute>
                            }
                        />
                        <Route
                            path="players/:id"
                            element={
                                <ProtectedRoute component={PlayerDetailPage} action="read"><PlayerDetailPage/></ProtectedRoute>
                            }
                        />

                        <Route
                            path="transactions"
                            element={
                                <ProtectedRoute component={TransactionsPage} action="read"><TransactionsPage/></ProtectedRoute>
                            }
                        />

                        <Route path="rewards" element={<RewardsPage/>}/>
                        <Route path="rewards/:id" element={<RewardDetailPage/>}/>

                        <Route path="currencies" element={<CurrenciesPage/>}/>
                        <Route path="currencies/:id" element={<CurrencyEditPage/>}/>

                        <Route path="minigames" element={<MinigamesPage/>}/>
                        <Route path="minigames/stats" element={<MinigameStatsPage/>}/>
                        <Route path="minigames/stats/:minigameId" element={<MinigameStatsDetailPage/>}/>
                        <Route path="minigames/stats/:minigameId/hilo" element={<HiLoStatsPage/>}/>
                        <Route path="minigames/:id" element={<MinigameEditPage/>}/>

                        <Route path="gelts" element={<GeltsPage/>}/>
                        <Route path="gelts/:id" element={<GeltEditPage/>}/>
                        <Route path="xp-level-configs" element={<XpLevelConfigsPage/>}/>
                        <Route path="xp-level-configs/:id" element={<XpLevelConfigEditPage/>}/>
                        <Route path="daily-bonus-configs" element={<DailyBonusConfigsPage/>}/>
                        <Route path="daily-bonus-configs/:id" element={<DailyBonusConfigEditPage/>}/>

                        <Route path="challenges" element={<ChallengesPage/>}/>
                        <Route path="challenges/:id" element={<ChallengeEditPage/>}/>

                        <Route path="levelplay-placements" element={<LevelPlayPlacementsPage/>}/>
                        <Route path="levelplay-placements/:id" element={<LevelPlayPlacementEditPage/>}/>

                        <Route path="/prize-categories" element={<PrizeCategoriesPage/>}/>
                        <Route path="/prize-categories/:id" element={<PrizeCategoryEditPage/>}/>

                        <Route path="/prize-items" element={<PrizeItemsPage/>}/>
                        <Route path="/prize-items/:id" element={<PrizeItemEditPage/>}/>

                        <Route index element={<Navigate to="/machines" replace/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;